import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Card, Flex, Input, Space, Typography } from 'antd';

const { Search } = Input;
const { Text } = Typography;

const TagMobile = ({ viewModel }) => {
  const {
    data,
    filter,
    setFilterValue,
    createTag,
    editTag,
    deleteTag,
  } = viewModel;

  return (
    <Space direction='vertical' size={16} style={{ width: '100%' }}>
      <Card style={{ width: '100%' }}>
        <Space direction='vertical' size={8} style={{ width: '100%' }}>
          <Search
            placeholder='Tên hoặc mã'
            onChange={(e) => setFilterValue('info', e.target.value)}
            style={{ width: '100%' }}
            value={filter.info}
          />

          <Flex justify='flex-end' style={{ width: '100%' }}>
            <Button type='primary' onClick={createTag}>Thêm mới</Button>
          </Flex>
        </Space>
      </Card>

      <Space direction='vertical' size={8} style={{ width: '100%' }}>
        {(data || []).map((record) => (
          <Card key={record.id} style={{ width: '100%' }} bodyStyle={{ padding: 12 }}>
            <Flex justify='space-between' align='center' gap={8}>
              <Text strong style={{ minWidth: 0 }} ellipsis={{ tooltip: record.name }}>
                {record.name}
              </Text>

              <Space size={4}>
                <Button icon={<EditOutlined />} onClick={() => editTag(record.id)}>
                  Sửa
                </Button>
                <Button danger icon={<DeleteOutlined />} onClick={() => deleteTag(record.id)}>
                  Xoá
                </Button>
              </Space>
            </Flex>
          </Card>
        ))}
      </Space>

      {(!data || data.length === 0) && (
        <Card style={{ width: '100%', textAlign: 'center', padding: '20px 12px' }}>
          <Text type='secondary'>Không có tag nào</Text>
        </Card>
      )}
    </Space>
  );
};

export default TagMobile;